import "core-js/modules/es6.number.constructor";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cookies from 'js-cookie';
import config from '@/config';
var cookieExpires = config.cookieExpires;
import packageTableMixins from '@/mixins/packageTableMixins';
import paramCustom from './components/paramCustom';
import configjrmCustom from './components/configjrmCustom';
import { get_device_info, dsgetconfigbyuser, iotconfigset, set_jrm } from '@/api/jingxiaoshang';
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      spinShow: true,
      search_name: "",
      device_type: 1,
      switch1: true,
      params_config_password: "",
      did1: "",
      columns4: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: this.$t('参数名'),
        key: 'name_cn'
      }, {
        title: this.$t('当前值'),
        key: 'now_value' // render: (h, { row }) => {
        //   let result = ""
        //   let color=''
        //   if (row.status === 1) {
        //     color=""
        //     result='离线'
        //   } else if (row.status === 2) {
        //     color=""
        //     result='在线'
        //   } else {
        //     color=""
        //     result='未知'
        //   }
        //   return h('Tag',{
        //       props:{
        //         color
        //       }
        //     },result)
        // }

      }, {
        title: this.$t('设置值'),
        key: 'config_value',
        slot: 'action'
      }, {
        title: this.$t('操作'),
        key: 'action',
        width: 150,
        align: 'center',
        render: function render(h, params) {
          if (params.row.name_en == "heatingfilm") {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this2.configjrm(params);
                }
              }
            }, _this2.$t('设置'))]);
          } else {
            return h('div', [h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: function click() {
                  _this2.send(params);
                }
              }
            }, _this2.$t('发送'))]);
          }
        }
      }],
      data1: {},
      checktab: 0,
      show1_0: true,
      show1_1: true,
      show1_2: true,
      show1_3: true,
      show1_4: true,
      show1_5: true,
      show1_6: true,
      show1_7: true,
      show1_8: true,
      show1_9: true,
      show1_10: true,
      show1_11: true,
      show1_12: true,
      show1_13: true,
      show1_14: true,
      show1_15: true,
      show1_16: true,
      show1_17: true,
      show1_18: true,
      show1_19: true,
      show1_20: true,
      show1_21: true,
      show1_22: true,
      show1_23: true,
      show1_24: true,
      show1_25: true,
      show1_26: true,
      show1_27: true,
      show1_28: true,
      show1_29: true,
      show1_30: true,
      show1_31: true,
      show1_32: true,
      tabData: [{
        name: "单体高压1",
        value: 1
      }, {
        name: "单体高压2",
        value: 2
      }, {
        name: "单体高压3",
        value: 3
      }, {
        name: "单体低压1",
        value: 4
      }, {
        name: "单体低压2",
        value: 5
      }, {
        name: "单体低压3",
        value: 6
      }, {
        name: "电池簇总体高压1",
        value: 7
      }, {
        name: "电池簇总体高压2",
        value: 8
      }, {
        name: "电池簇总体高压3",
        value: 9
      }, {
        name: "电池簇总体低压1",
        value: 10
      }, {
        name: "电池簇总体低压2",
        value: 11
      }, {
        name: "电池簇总体低压3",
        value: 12
      }, {
        name: "充电过流1",
        value: 13
      }, {
        name: "充电过流2",
        value: 14
      }, {
        name: "充电过流3",
        value: 15
      }, {
        name: "放电过流1",
        value: 16
      }, {
        name: "放电过流2",
        value: 17
      }, {
        name: "放电过流3",
        value: 18
      }, {
        name: "充电高温1",
        value: 19
      }, {
        name: "充电高温2",
        value: 20
      }, {
        name: "充电高温3",
        value: 21
      }, {
        name: "充电低温1",
        value: 22
      }, {
        name: "充电低温2",
        value: 23
      }, {
        name: "充电低温3",
        value: 24
      }, {
        name: "放电高温1",
        value: 25
      }, {
        name: "放电高温2",
        value: 26
      }, {
        name: "放电高温3",
        value: 27
      }, {
        name: "放电低温1",
        value: 28
      }, {
        name: "放电低温2",
        value: 29
      }, {
        name: "放电低温3",
        value: 30
      }, {
        name: "充电温差1",
        value: 31
      }, {
        name: "充电温差2",
        value: 32
      }, {
        name: "充电温差3",
        value: 33
      }, {
        name: "放电温差1",
        value: 34
      }, {
        name: "放电温差2",
        value: 35
      }, {
        name: "放电温差3",
        value: 36
      }, {
        name: "电芯温升1",
        value: 37
      }, {
        name: "电芯温升2",
        value: 38
      }, {
        name: "电芯温升3",
        value: 39
      }, {
        name: "SOC高1",
        value: 40
      }, {
        name: "SOC高2",
        value: 41
      }, {
        name: "SOC高3",
        value: 42
      }, {
        name: "SOC低1",
        value: 43
      }, {
        name: "SOC低2",
        value: 44
      }, {
        name: "SOC低3",
        value: 45
      }, {
        name: "正极绝缘漏电1",
        value: 46
      }, {
        name: "正极绝缘漏电2",
        value: 47
      }, {
        name: "正极绝缘漏电3",
        value: 48
      }, {
        name: "负极绝缘漏电1",
        value: 49
      }, {
        name: "负极绝缘漏电2",
        value: 50
      }, {
        name: "负极绝缘漏电3",
        value: 51
      }, {
        name: "环境高温1",
        value: 52
      }, {
        name: "环境高温2",
        value: 53
      }, {
        name: "环境高温3",
        value: 54
      }, {
        name: "环境低温1",
        value: 55
      }, {
        name: "环境低温2",
        value: 56
      }, {
        name: "环境低温3",
        value: 57
      }, {
        name: "充电压差1",
        value: 58
      }, {
        name: "充电压差2",
        value: 59
      }, {
        name: "充电压差3",
        value: 60
      }, {
        name: "放电压差1",
        value: 61
      }, {
        name: "放电压差2",
        value: 62
      }, {
        name: "放电压差3",
        value: 63
      }, {
        name: "端子高温1",
        value: 64
      }, {
        name: "端子高温2",
        value: 65
      }, {
        name: "端子高温3",
        value: 66
      }, {
        name: "风扇控制",
        value: 67
      }, {
        name: "电芯故障",
        value: 68
      }, {
        name: "满充参数",
        value: 69
      }, {
        name: "均衡参数",
        value: 70
      }, {
        name: "容量",
        value: 71
      }, {
        name: "短路保护",
        value: 72
      }, {
        name: "掉电关机",
        value: 73
      }, {
        name: "继电器控制",
        value: 74
      }, {
        name: "功能参数",
        value: 75
      }],
      tabData2: [{
        name: "单体高压",
        value: 1
      }, {
        name: "单体低压",
        value: 2
      }, {
        name: "总体高压",
        value: 3
      }, {
        name: "总体低压",
        value: 4
      }, {
        name: "充电过流1",
        value: 5
      }, {
        name: "充电过流2",
        value: 6
      }, {
        name: "放电过流1",
        value: 7
      }, {
        name: "放电过流2",
        value: 8
      }, {
        name: "充电高温",
        value: 9
      }, {
        name: "充电低温",
        value: 10
      }, {
        name: "放电高温",
        value: 11
      }, {
        name: "放电低温",
        value: 12
      }, {
        name: "环境高温",
        value: 13
      }, {
        name: "环境低温",
        value: 14
      }, {
        name: "MOS高温",
        value: 15
      }, {
        name: "满充参数",
        value: 16
      }, {
        name: "均衡参数",
        value: 17
      }, {
        name: "容量",
        value: 18
      }, {
        name: "短路保护",
        value: 19
      }, {
        name: "休眠",
        value: 20
      }, {
        name: "继电器控制",
        value: 21
      }, {
        name: "功能参数",
        value: 22
      }],
      tabData3: [{
        name: "单体高压1",
        value: 1
      }, {
        name: "单体高压2",
        value: 2
      }, {
        name: "单体高压3",
        value: 3
      }, {
        name: "单体低压1",
        value: 4
      }, {
        name: "单体低压2",
        value: 5
      }, {
        name: "单体低压3",
        value: 6
      }, {
        name: "总体高压1",
        value: 7
      }, {
        name: "总体高压2",
        value: 8
      }, {
        name: "总体高压3",
        value: 9
      }, {
        name: "总体低压1",
        value: 10
      }, {
        name: "总体低压2",
        value: 11
      }, {
        name: "总体低压3",
        value: 12
      }, {
        name: "充电过流1",
        value: 13
      }, {
        name: "充电过流2~3",
        value: 14
      }, // { name: "充电过流3", value: 15 },
      {
        name: "放电过流1",
        value: 15
      }, {
        name: "放电过流2~3",
        value: 16
      }, //{ name: "放电过流3" ,value:18},
      {
        name: "充电高温1",
        value: 17
      }, {
        name: "充电高温2",
        value: 18
      }, {
        name: "充电高温3",
        value: 19
      }, {
        name: "充电低温1",
        value: 20
      }, {
        name: "充电低温2",
        value: 21
      }, {
        name: "充电低温3",
        value: 22
      }, {
        name: "放电高温1",
        value: 23
      }, {
        name: "放电高温2",
        value: 24
      }, {
        name: "放电高温3",
        value: 25
      }, {
        name: "放电低温1",
        value: 26
      }, {
        name: "放电低温2",
        value: 27
      }, {
        name: "放电低温3",
        value: 28
      }, {
        name: "充电温差1",
        value: 29
      }, {
        name: "充电温差2",
        value: 30
      }, {
        name: "充电温差3",
        value: 31
      }, {
        name: "放电温差1",
        value: 32
      }, {
        name: "放电温差2",
        value: 33
      }, {
        name: "放电温差3",
        value: 34
      }, {
        name: "电芯温升1",
        value: 35
      }, {
        name: "电芯温升2",
        value: 36
      }, {
        name: "电芯温升3",
        value: 37
      }, {
        name: "SOC高1",
        value: 38
      }, {
        name: "SOC高2",
        value: 39
      }, {
        name: "SOC高3",
        value: 40
      }, {
        name: "SOC低1",
        value: 41
      }, {
        name: "SOC低2",
        value: 42
      }, {
        name: "SOC低3",
        value: 43
      }, {
        name: "正极绝缘漏电1",
        value: 44
      }, {
        name: "正极绝缘漏电2",
        value: 45
      }, {
        name: "正极绝缘漏电3",
        value: 46
      }, {
        name: "负极绝缘漏电1",
        value: 47
      }, {
        name: "负极绝缘漏电2",
        value: 48
      }, {
        name: "负极绝缘漏电3",
        value: 49
      }, {
        name: "环境高温1",
        value: 50
      }, {
        name: "环境高温2",
        value: 51
      }, {
        name: "环境高温3",
        value: 52
      }, {
        name: "环境低温1",
        value: 53
      }, {
        name: "环境低温2",
        value: 54
      }, {
        name: "环境低温3",
        value: 55
      }, {
        name: "充电压差1",
        value: 56
      }, {
        name: "充电压差2",
        value: 57
      }, {
        name: "充电压差3",
        value: 58
      }, {
        name: "放电压差1",
        value: 59
      }, {
        name: "放电压差2",
        value: 60
      }, {
        name: "放电压差3",
        value: 61
      }, {
        name: "快充口高温1",
        value: 62
      }, {
        name: "快充口高温2",
        value: 63
      }, {
        name: "快充口高温3",
        value: 64
      }, {
        name: "慢充电口高温1",
        value: 65
      }, {
        name: "慢充电口高温2",
        value: 66
      }, {
        name: "慢充电口高温3",
        value: 67
      }, {
        name: "放电口高温1",
        value: 68
      }, {
        name: "放电口高温2",
        value: 69
      }, {
        name: "放电口高温3",
        value: 70
      }, {
        name: "正极端子高温1",
        value: 71
      }, {
        name: "正极端子高温2",
        value: 72
      }, {
        name: "正极端子高温3",
        value: 73
      }, {
        name: "负极端子高温1",
        value: 74
      }, {
        name: "负极端子高温2",
        value: 75
      }, {
        name: "负极端子高温3",
        value: 76
      }, {
        name: "风扇控制",
        value: 77
      }, {
        name: "电芯故障",
        value: 78
      }, {
        name: "满充参数",
        value: 79
      }, {
        name: "均衡参数",
        value: 80
      }, {
        name: "容量",
        value: 81
      }, {
        name: "短路保护",
        value: 82
      }, {
        name: "掉电关机",
        value: 83
      }, {
        name: "Ntc采样异常1",
        value: 84
      }, {
        name: "Ntc采样异常2",
        value: 85
      }, {
        name: "Ntc采样异常3",
        value: 86
      }, {
        name: "电芯采样异常1",
        value: 87
      }, {
        name: "电芯采样异常2",
        value: 88
      }, {
        name: "电芯采样异常3",
        value: 89
      }, {
        name: "加热膜参数",
        value: 90
      }, {
        name: "继电器控制",
        value: 91
      }, {
        name: "功能参数",
        value: 92
      }],
      config_data: [],
      form_filter: {
        tabname: null
      },
      ids: [],
      //共用的查询与重置
      topButtonList: [{
        name: this.$t('查询'),
        type: 'primary',
        method: this.search
      }, {
        name: this.$t('重置'),
        type: 'error',
        method: this.reset
      }]
    };
  },
  methods: {
    switchchange: function switchchange(event, row, default_value, index) {
      console.log(event);
      console.log(row['tab_name']);
      console.log(index); // row.name_en2=zhi

      this.data1[row['tab_name']][index].name_en2 = event;
    },
    refresh: function refresh(row, default_value, index) {
      //console.log(111)
      //debugger 
      // debugger
      // let vm = this; 
      //   console.log(this.data1)
      // console.log(vm.data1[pindex])
      // console.log(vm.data1[pindex][cindex])
      this.data1[row['tab_name']][index].name_en2 = default_value; //  this.name_en2=default_value
    },
    clicktab: function clicktab(name) {
      debugger;
      this.checktab = name; // alert(name)

      if (name === undefined) {
        if (Object.keys(this.data1).length > 0) {
          var _name = Object.keys(this.data1)[0];
          this.search_name = _name;
          this.$set(this, 'search_name', _name);
        }
      } else {
        this.search_name = name;
        console.log('12131131', name);
      }
    },
    piliang_send: function piliang_send() {
      var _this3 = this;

      var vm = this;
      var arr = [];

      for (var index in this.data1) {
        arr.push(index);
      }

      console.log(arr);
      console.log("xiaoxie", this.checktab);
      var config_data = [];
      var tab_name = "";

      if (this.checktab == 0) {
        tab_name = arr[this.checktab];
      } else {
        tab_name = this.checktab;
      }

      console.log("小谢2", tab_name);

      for (var i = 0; i < this.data1[tab_name].length; i++) {
        var arrinner = {
          "name": "",
          "value": "",
          "type": ""
        };
        arrinner['name'] = this.data1[tab_name][i].name_en;
        arrinner['type'] = this.data1[tab_name][i].type;
        arrinner['value'] = this.data1[tab_name][i].name_en2 !== "" ? this.data1[tab_name][i].name_en2 : this.data1[tab_name][i].now_value_num;
        console.log(this.data1[tab_name][i].name_en2);
        config_data.push(arrinner);
      }

      if (tab_name == "容量") {
        var sj = 0;
        var mc = 0;
        var sy = 0;

        if (this.data1[tab_name][0].name_en2 == "") {
          sj = this.data1[tab_name][0].now_value_num;
        } else {
          sj = this.data1[tab_name][0].name_en2;
        }

        if (this.data1[tab_name][1].name_en2 == "") {
          sy = this.data1[tab_name][1].now_value_num;
        } else {
          sy = this.data1[tab_name][1].name_en2;
        }

        if (this.data1[tab_name][2].name_en2 == "") {
          mc = this.data1[tab_name][2].now_value_num;
        } else {
          mc = this.data1[tab_name][2].name_en2;
        }

        console.log("sj", sj);
        console.log("sy", sy);
        console.log("mc", mc);

        if (sj < mc) {
          // || mc < sj 设计容量>=满充容量>=剩余容量
          this.$Message.error(this.$t('设计容量不能小于满充容量'));
          return;
        }

        if (mc < sy) {
          this.$Message.error(this.$t('满充容量不能小于剩余容量'));
          return;
        }
      }

      this.config_data = config_data;
      var confirm_password = Cookies.get('confirm_password');

      if (confirm_password == 1) {
        iotconfigset({
          "did": vm.did1,
          "config_data": vm.config_data
        }).then(function (res) {
          var msg = res.errorMsg;

          if (res.result === 0) {
            var _msg = res.errorMsg;
            vm.$Message.success(_msg);
            vm.$Modal.remove(); //判断是否设置弹框参数
            //const confirm_password = Cookies.get(confirm_password)

            Cookies.set('confirm_password', 1, {
              expires: cookieExpires || 1
            });
            setTimeout(function () {
              vm.init();
            }, 6000);
          } else {
            vm.$Message.error(msg);
            _this.buttonLoading = false;
          }
        });
      } else {
        // alert(confirm_password);  
        // return;
        var _config = {
          loading: true,
          width: 500,
          render: function render(h) {
            return h('div', [h('div', {
              style: {
                display: 'flex',
                justifyContent: 'space-between'
              }
            }, [h('h3', {
              style: {
                width: '100%',
                paddingBottom: '5px'
              }
            }, _this3.$t('请输入参数设置密码')), h('icon', {
              props: {
                type: 'md-close',
                size: '16'
              },
              style: {
                cursor: 'pointer'
              },
              on: {
                'click': function click(evt) {
                  vm.$Modal.remove();
                }
              }
            })]), h('Divider', {
              style: {
                margin: '8px 0'
              }
            }), h(paramCustom, {
              ref: 'paramCustom',
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                setData: {
                  "params_config_password": _this3.params_config_password,
                  "did": _this3.did1
                }
              }
            })]);
          },
          onOk: function onOk() {
            var _this = this;

            var obj = this.$refs.paramCustom;
            obj.checkForm().then(function (res) {
              if (res) {
                // console.log("asdf", obj.formModel)
                // return;
                //let config_data_inner = { "name": params.row.name_en, "value": params.row.name_en2}
                //   let config_data = vm.ids
                console.log(222);
                console.log(vm.config_data); //return;

                iotconfigset(_objectSpread({}, obj.formModel, {
                  "config_data": vm.config_data
                })).then(function (res) {
                  var msg = res.errorMsg;

                  if (res.result === 0) {
                    var _msg2 = res.errorMsg;
                    vm.$Message.success(_msg2);
                    vm.$Modal.remove(); //判断是否设置弹框参数
                    //const confirm_password = Cookies.get(confirm_password)

                    localStorage.setItem('confirm_password', 1);
                    setTimeout(function () {
                      vm.init();
                    }, 6000);
                  } else {
                    vm.$Message.error(msg);
                    _this.buttonLoading = false;
                  }
                });
              } else {
                _this.buttonLoading = false;
              }
            });
          }
        };
        this.$Modal.confirm(_config);
      }
    },
    selection_change: function selection_change(SelectItem) {
      //多选操作
      this.ids.splice(0);

      if (SelectItem && SelectItem.length > 0) {
        for (var i in SelectItem) {
          var list = SelectItem[i];
          console.log(list);
          this.ids.push({
            "name": list.name_en,
            "value": list.name_en2,
            'type': list.type
          });
        }
      } //  console.log("aaa",this.ids)

    },
    inputchange: function inputchange(event, row, default_value, index) {
      console.log("xiaoxie1", event);
      console.log(event['target']['_value']);
      console.log("xiaxie2", row);
      console.log("xiaoxie3", index); //     $a=299;
      // $beilv=1;
      // $zhi=$beilv*floor($a/$beilv);
      // print_R($zhi);
      // exit;

      var pattern = /^[+-]?\d*\.?\d*$/;
      var testStr = pattern.test(event['target']['_value']);

      if (!testStr) {
        row.name_en2 = 0;
        this.data1[row['tab_name']][index].name_en2 = 0;
        this.$Message.error("输入值非法"); //this.data1[row['tab_name']][index].name_en2=""
      }

      var zhi = 0;
      zhi = row['beilv'] * Math.round(event['target']['_value'] / row['beilv']); //console.log("a",zhi)

      if (zhi < row['min_value']) {
        console.log("xiaoyu");
        zhi = row['min_value'];
      }

      if (zhi > row['max_value']) {
        zhi = row['max_value'];
      } //if (zhi / 1 == 0) {


      zhi = Number(zhi);

      if (this.hasDecimal(zhi)) {
        zhi = zhi.toFixed(2);
      } //}


      console.log("b", zhi); //console.log(this.data1[row['tab_name']][index].name_en2)

      row.name_en2 = zhi;
      this.data1[row['tab_name']][index].name_en2 = zhi;
    },
    hasDecimal: function hasDecimal(num) {
      return /\./.test(num);
    },
    refresh2: function refresh2(data1) {
      //alert(this.checktab);
      //console.log(data1)
      // for (var index in data1) {
      //     console.log(index);
      // }
      var arr = [];

      for (var index in data1) {
        arr.push(index);
      }

      var tab_name = "";

      if (this.checktab == 0) {
        tab_name = arr[this.checktab];
      } else {
        tab_name = this.checktab;
      }

      console.log("this.checktab", this.checktab, arr[this.checktab]);

      for (var i = 0; i < this.data1[tab_name].length; i++) {
        // console.log(this.data1[arr[this.checktab]][i])
        this.data1[tab_name][i]['name_en2'] = this.data1[tab_name][i]['default_value']; // console.log
      } //console.log(this.data1[arr[this.checktab]])
      //this.data1[arr[this.checktab]][index].name_en2=default_value
      //console.log(arr)
      // for (let i = 1; i <= data1.length; i++){
      //   // str = ""+"show1_" + i;
      //   // this[str] = true;
      //   console.log(i)
      // }

    },
    configjrm: function configjrm(params) {
      var _this4 = this;

      // console.log("params", params);
      // return;
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, vm.$t('加热膜控制')), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(configjrmCustom, {
            ref: 'configjrmCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              setData: {
                "jrm_value": params.row.dqz,
                "did": _this4.did1
              }
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.configjrmCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              set_jrm({
                "did": obj.formModel.did,
                'jrm_value': obj.formModel.jrm_value
              }).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg3 = res.errorMsg; //0, 自动; 1, 常闭; 2, 常开; 3, 定时开关

                  var now_value = "";

                  if (obj.formModel.jrm_value == 0) {
                    now_value = "自动";
                  } else if (obj.formModel.jrm_value == 1) {
                    now_value = "常闭";
                  } else if (obj.formModel.jrm_value == 2) {
                    now_value = "常开";
                  } else if (obj.formModel.jrm_value == 3) {
                    now_value = "定时开关";
                  }

                  vm.data1['继电器控制'][2].now_value = now_value;
                  vm.data1['继电器控制'][2].dqz = obj.formModel.jrm_value;
                  vm.$Message.success(_msg3);
                  vm.$Modal.remove();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    send: function send(params) {
      var _this5 = this;

      // console.log("params",params)
      // return;
      //判断大小 设计容量>=满充容量>=剩余容量
      if (params.row['tab_name'] == "容量") {
        var sj = 0;
        var mc = 0;
        var sy = 0;

        if (this.data1[params.row['tab_name']][0].name_en2 == "") {
          sj = this.data1[params.row['tab_name']][0].now_value_num;
        } else {
          sj = this.data1[params.row['tab_name']][0].name_en2;
        }

        if (this.data1[params.row['tab_name']][1].name_en2 == "") {
          sy = this.data1[params.row['tab_name']][1].now_value_num;
        } else {
          sy = this.data1[params.row['tab_name']][1].name_en2;
        }

        if (this.data1[params.row['tab_name']][2].name_en2 == "") {
          mc = this.data1[params.row['tab_name']][2].now_value_num;
        } else {
          mc = this.data1[params.row['tab_name']][2].name_en2;
        }

        console.log("sj", sj);
        console.log("sy", sy);
        console.log("mc", mc);

        if (sj < mc) {
          // || mc < sj 设计容量>=满充容量>=剩余容量
          this.$Message.error(this.$t('设计容量不能小于满充容量'));
          return;
        }

        if (mc < sy) {
          this.$Message.error(this.$t('满充容量不能小于剩余容量'));
          return;
        }
      } // return;


      var vm = this;
      var confirm_password = Cookies.get('confirm_password');

      if (confirm_password == 1) {
        var config_data_inner = {
          "name": params.row.name_en,
          "value": params.row.name_en2,
          'type': params.row.type
        };
        var config_data = [config_data_inner];
        iotconfigset({
          "did": vm.did1,
          "config_data": config_data
        }).then(function (res) {
          var msg = res.errorMsg;

          if (res.result === 0) {
            var _msg4 = res.errorMsg;
            vm.$Message.success(_msg4);
            vm.$Modal.remove();
            Cookies.set("confirm_password", 1, {
              expires: cookieExpires || 1
            });
            setTimeout(function () {
              vm.init();
            }, 6000);
          } else {
            vm.$Message.error(msg);
            _this.buttonLoading = false;
          }
        });
      } else {
        var _config2 = {
          loading: true,
          width: 500,
          render: function render(h) {
            return h('div', [h('div', {
              style: {
                display: 'flex',
                justifyContent: 'space-between'
              }
            }, [h('h3', {
              style: {
                width: '100%',
                paddingBottom: '5px'
              }
            }, _this5.$t('请输入参数设置密码')), h('icon', {
              props: {
                type: 'md-close',
                size: '16'
              },
              style: {
                cursor: 'pointer'
              },
              on: {
                'click': function click(evt) {
                  vm.$Modal.remove();
                }
              }
            })]), h('Divider', {
              style: {
                margin: '8px 0'
              }
            }), h(paramCustom, {
              ref: 'paramCustom',
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                setData: {
                  "params_config_password": _this5.params_config_password,
                  "did": _this5.did1
                }
              }
            })]);
          },
          onOk: function onOk() {
            var _this = this;

            var obj = this.$refs.paramCustom;
            obj.checkForm().then(function (res) {
              if (res) {
                var _config_data_inner = {
                  "name": params.row.name_en,
                  "value": params.row.name_en2,
                  'type': params.row.type
                };
                var _config_data = [_config_data_inner];
                console.log("单个发送");
                console.log(_config_data); // return;

                iotconfigset(_objectSpread({}, obj.formModel, {
                  "config_data": _config_data
                })).then(function (res) {
                  var msg = res.errorMsg;

                  if (res.result === 0) {
                    var _msg5 = res.errorMsg;
                    vm.$Message.success(_msg5);
                    vm.$Modal.remove();
                    Cookies.set("confirm_password", 1, {
                      expires: cookieExpires || 1
                    });
                    setTimeout(function () {
                      vm.init();
                    }, 6000);
                  } else {
                    vm.$Message.error(msg);
                    _this.buttonLoading = false;
                  }
                });
              } else {
                _this.buttonLoading = false;
              }
            });
          }
        };
        this.$Modal.confirm(_config2);
      }
    },
    init: function init() {
      var _this6 = this;

      this.spinShow = true; //alert("123")

      var q = this.$route.query;
      this.did1 = q.did; //获取设备信息

      get_device_info({
        "did": this.did1
      }).then(function (res) {
        _this6.tableLoading = false;
        _this6.tableDataList = [];

        if (res.result === 0) {
          // console.log(res)
          // return
          _this6.params_config_password = res.body.params_config_password;
        } else {
          _this6.tableDataList = [];
          _this6.getPageTotal = 0;

          _this6.$Message.error(res.errorMsg);
        }
      }); //拉取tab及其内容

      dsgetconfigbyuser({
        "did": this.did1
      }).then(function (res) {
        _this6.tableLoading = true;
        _this6.tableDataList = [];

        if (res.result === 0) {
          console.log('res.body.data', res.body.data); // return 

          _this6.data1 = res.body.data;

          if (Object.keys(_this6.data1).length > 0) {
            _this6.search_name = _this6.search_name || Object.keys(_this6.data1)[0]; // this.clicktab(this.search_name)
          }

          _this6.device_type = res.other.device.device_type;

          if (res.other.device.device_type == 2) {
            // alert(123); 
            _this6.tabData = _this6.tabData2;
          } else if (res.other.device.device_type == 3) {
            _this6.tabData = _this6.tabData3;
          }

          _this6.tableLoading = false;
          _this6.spinShow = false;
        } else {
          _this6.spinShow = false;
          _this6.tableDataList = [];
          _this6.getPageTotal = 0;
          _this6.tableLoading = false;

          _this6.$Message.error(res.errorMsg);
        }
      });
    },
    handleSelectAll: function handleSelectAll(status) {
      this.$refs.selection.selectAll(status);
    },
    reset: function reset() {
      this.form_filter = {
        tabname: null
      };
      console.log(this.tabData);
      this.checktab = 0;
      this.search();
    },
    search: function search() {
      var arr = [];

      for (var index in this.data1) {
        arr.push(index);
      } //console.log("111", this.form_filter.tabname)


      if (this.form_filter.tabname == null) {
        this.search_name = arr[0]; //console.log(this.search_name)

        for (var i = 0; i <= 100; i++) {
          this.data1[arr[i]][0]['web_show'] = true;
        }

        return;
      }

      var arr2 = [];
      arr2 = [this.form_filter.tabname - 1]; //console.log("222",arr2)  

      for (var _i = 0; _i <= 100; _i++) {
        if (arr2.indexOf(_i) == -1) {
          //不存在
          this.data1[arr[_i]][0]['web_show'] = false;
        } else {
          //存在
          //  console.log("arr",arr[i])
          this.search_name = arr[_i];
          this.data1[arr[_i]][0]['web_show'] = true;
          this.checktab = arr[_i];
        }
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
};